import { FormComponent } from "./components/form/form.component";
import { TitleComponent } from "./components/title/title.components";
import { Base } from "./newsletter.base";

export const Newsletter = Object.assign(Base, {
    Title: TitleComponent,
    Form: FormComponent
});
